<template>
  <card>
    <div class="card-header" style="cursor: pointer;">
      <h4 class="card-title"> Could not find anything</h4>
    </div>
  </card>
</template>

<script>
    export default {
      name: "empty-data-row"
    }
</script>

<style scoped>

</style>
